module.exports = {
  HotspotImages: {
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Opaklık",
    padding: "Alan",
    pos: "Konum",
    PluginName: "Resim",
    radius: "Radyan",
    source: "Kaynak",
    scale: "Zoom",
    message_mark_xy: "Yanlış bir değer seçtiniz. Sayıları birbirinden virgül ile ayırmalısınız",
    hyperlink: "Link",
    link_placeholder: "http://...",
    allowDeformed: "Konteyner Ayarı",
    replayWebp: "Sahne başladığında tekrar oynat (WebP)",
  },
};
